export const UPDATE_STATUS  = 'UPDATE_STATUS';
export const READY  = 'READY';
export const SHOW_LOADING  = 'SHOW_LOADING';
export const HIDE_LOADING  = 'HIDE_LOADING';

export const  TIMER_QUERY_START = 'TIMER_REQUEST_START';
export const  TIMER_QUERY = 'TIMER_QUERY';
export const  TIMER_QUERY_SUCCESS = 'TIMER_QUERY_SUCCESS';
export const  TIMER_QUERY_FAIL = 'TIMER_QUERY_FAIL';
export const  TIMER_RESET = 'TIMER_RESET';
export const  SET_CURRENT_TIMERS = 'SET_CURRENT_TIMERS';
export const  SET_CURRENT_TYPE = 'SET_CURRENT_TYPE';
export const  UPDATE_CURRENT_TIMER = 'UPDATE_CURRENT_TIMER';
export const  TIMER_ADD = 'TIMER_ADD';
export const  TIMER_DELETE = 'TIMER_DELETE';
export const  TIMER_ADD_SUCCESS = 'TIMER_ADD_SUCCESS';
export const  TIMER_DELETE_SUCCESS = 'TIMER_DELETE_SUCCESS';
export const  TIMER_EDIT_SUCCESS = 'TIMER_EDIT_SUCCESS';
export const  UPDATE_CURRENT_TIMER_REPEAT = 'UPDATE_CURRENT_TIMER_REPEAT';
export const  SUN_CONFIGURE = 'SUN_CONFIGURE';
export const  SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
export const  SET_LOCATION_EN = 'SET_LOCATION_EN';

